import { useContext } from 'react'

import { ImageFormatContext } from '@/components/ImageFormatProvider/ImageFormatProvider'

export const useImageFormatContext = () => {
  const context = useContext(ImageFormatContext)
  if (context === undefined) {
    throw new Error('useImageFormatContext must be used within an ImageFormatProvider')
  }
  return context
}
